// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_ko-1";
export var quotedThread = "_ko-0";